import { useDispatch, useSelector } from 'react-redux';
import { BASEMAP_OPTIONS } from '../../constants/general';
import { setBasemap } from '../../store/actions/general';
import { basemapSelector } from '../../store/selectors/general';
import { trackEvent, MAP_SELECT_BASEMAP } from '../../utils/googleAnalytics';
import { ButtonGroup } from '../general/ButtonGroup';

export const BasemapOptions = () => {
  const dispatch = useDispatch();

  const baseMapInfo = useSelector(basemapSelector);

  const handleBasemapChange = id => {
    trackEvent(MAP_SELECT_BASEMAP, { basemap: id });

    dispatch(setBasemap(id));
  };
  return (
    <div className="absolute left-2 top-24 z-[1000]">
      <ButtonGroup
        id="basemap-options"
        options={BASEMAP_OPTIONS}
        currentValue={baseMapInfo}
        handleChange={handleBasemapChange}
        format="vertical"
      />
    </div>
  );
};
